import type { Template } from "@/types";

export const LA_03_H0_V3: Template[] = [
{
    id: "la-03-h0v3-01",
    name: "LA 01 - H0V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 54, y: 62, width: 261, height: 351, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 62, width: 261, height: 351, rotation: 0, imageRotation: 0 },
            { id: "3", x: 773, y: 0, width: 366, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h0v3-02",
    name: "LA 02 - H0V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 54, y: 43, width: 261, height: 389, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 43, width: 261, height: 389, rotation: 0, imageRotation: 0 },
            { id: "3", x: 930, y: 43, width: 288, height: 389, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h0v3-03",
    name: "LA 03 - H0V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 135, y: 0, width: 368, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 743, y: 74, width: 221, height: 325, rotation: 0, imageRotation: 0 },
            { id: "3", x: 972, y: 74, width: 221, height: 325, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h0v3-04",
    name: "LA 04 - H0V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 198, y: 80, width: 242, height: 316, rotation: 0, imageRotation: 0 },
            { id: "2", x: 728, y: 80, width: 223, height: 316, rotation: 0, imageRotation: 0 },
            { id: "3", x: 959, y: 80, width: 223, height: 316, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h0v3-05",
    name: "LA 05 - H0V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 68, y: 55, width: 285, height: 366, rotation: 0, imageRotation: 0 },
            { id: "2", x: 360, y: 55, width: 285, height: 366, rotation: 0, imageRotation: 0 },
            { id: "3", x: 652, y: 55, width: 285, height: 366, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h0v3-06",
    name: "LA 06 - H0V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_06.png",
    size: [1274, 476],
    style: {},
    slots: [
        { id: "1", x: 207, y: 56, width: 281, height: 365, rotation: 0, imageRotation: 0 },
        { id: "2", x: 496, y: 56, width: 281, height: 365, rotation: 0, imageRotation: 0 },
        { id: "3", x: 785, y: 56, width: 281, height: 365, rotation: 0, imageRotation: 0 }
    ],
  
},

{
    id: "la-03-h0v3-07",
    name: "LA 07 - H0V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_07.png",
    size: [1274, 476],
    style: {},
    slots: [
        { id: "1", x: 255, y: 73, width: 249, height: 330, rotation: 0, imageRotation: 0 },
        { id: "2", x: 512, y: 73, width: 249, height: 330, rotation: 0, imageRotation: 0 },
        { id: "3", x: 769, y: 73, width: 248, height: 330, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h0v3-08",
    name: "LA 08 - H0V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 43, y: 38, width: 271, height: 401, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 38, width: 271, height: 401, rotation: 0, imageRotation: 0 },
            { id: "3", x: 796, y: 38, width: 319, height: 401, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h0v3-09",
    name: "LA 09 - H0V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 44, y: 38, width: 295, height: 401, rotation: 0, imageRotation: 0 },
            { id: "2", x: 755, y: 77, width: 235, height: 318, rotation: 0, imageRotation: 0 },
            { id: "3", x: 997, y: 77, width: 235, height: 318, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-03-h0v3-10",
    name: "LA 10 - H0V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 89, y: 72, width: 271, height: 352, rotation: 0, imageRotation: 0 },
            { id: "2", x: 454, y: 0, width: 365, height: 476, rotation: 0, imageRotation: 0 },
            { id: "3", x: 914, y: 72, width: 271, height: 352, rotation: 0, imageRotation: 0 }
    ],
}
];